import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2256b341"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading text-center mb20" }, "閲覧数ランキング", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("日付指定で検索")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "mt20" }
const _hoisted_5 = ["innerHTML"]

import { useStore } from "vuex";
import { computed, onMounted, ref, watch } from 'vue';
import { QuestionViewRankingLogic } from "@/logic/question/QuestionViewRankingLogic";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const { getReport, viewRankings, viewRnakingsLoading } = QuestionViewRankingLogic();
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);

const order = ref('desc');

onMounted(async (): Promise<void> => {
  getReport();
});
const daterange = ref<Date[]>([]);
const rangeSearch = () => {
  if (daterange.value && daterange.value[0] && daterange.value[1]) {
    getReport({ start_date: daterange.value[0].toString(), end_date: daterange.value[1].toString(), order: order.value });
  } else {
    getReport({ start_date: '', end_date: '', order: order.value });
  }
}
watch(order, () => {
  rangeSearch();
});
const disabledDate = (time: Date) => {
  let beforeTwoMonth = new Date
  beforeTwoMonth.setMonth(beforeTwoMonth.getMonth() - 2)
  if (time.getTime() < beforeTwoMonth.getTime()) {
    return true;
  }
  return time.getTime() > Date.now()
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(managerFlg))
    ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "box-card" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_component_el_date_picker, {
                    modelValue: daterange.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((daterange).value = $event)),
                    type: "daterange",
                    "range-separator": "〜",
                    "start-placeholder": "開始日",
                    "end-placeholder": "終了日",
                    "value-format": "YYYY-MM-DD",
                    "disabled-date": disabledDate,
                    class: "mb20"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: rangeSearch,
                    class: "align"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _hoisted_3,
                  _createVNode(_component_el_select, {
                    modelValue: order.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((order).value = $event)),
                    class: "m-2",
                    placeholder: "Select",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "閲覧数降順",
                        value: "desc",
                        key: "desc"
                      }),
                      _createVNode(_component_el_option, {
                        label: "閲覧数昇順",
                        value: "asc",
                        key: "asc"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_table, {
                      data: _unref(viewRankings),
                      style: {"width":"100%"},
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "閲覧数",
                          width: "65"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_router_link, {
                              to: { name: 'ProjectQuestion', params: { project_id: _ctx.$route.params.project_id, question_id: scope.row.id } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.view_count), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "いいね数",
                          width: "80"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_router_link, {
                              to: { name: 'ProjectQuestion', params: { project_id: _ctx.$route.params.project_id, question_id: scope.row.id } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.iine_count), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "カテゴリ",
                          width: "150"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_router_link, {
                              to: { name: 'ProjectQuestion', params: { project_id: _ctx.$route.params.project_id, question_id: scope.row.id } },
                              target: "_blank",
                              class: "text-left"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.category_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Q一覧" }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_router_link, {
                              to: { name: 'ProjectQuestion', params: { project_id: _ctx.$route.params.project_id, question_id: scope.row.id } },
                              target: "_blank",
                              class: "text-left"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  innerHTML: scope.row.body_html
                                }, null, 8, _hoisted_5)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "作成者",
                          width: "90"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_router_link, {
                              to: { name: 'ProjectQuestion', params: { project_id: _ctx.$route.params.project_id, question_id: scope.row.id } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.user_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "作成日",
                          width: "140"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_router_link, {
                              to: { name: 'ProjectQuestion', params: { project_id: _ctx.$route.params.project_id, question_id: scope.row.id } },
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.post_at), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ], 512), [
                    [_directive_loading, _unref(viewRnakingsLoading)]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})